<template>
  <el-dialog
    title="请输入主机密码"
    :visible.sync="visibleProxy"
    width="420px"
    top="0"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    append-to-body
    class="host-password-dialog"
    @closed="handleClosed"
  >
    <div class="host-password-dialog__content">
      <p>请输入登录状态中保存的主机密码，校验通过后才能核对下发协议。</p>
      <el-input
        ref="passwordInput"
        v-model="password"
        type="password"
        show-password
        autocomplete="new-password"
        placeholder="请输入主机密码"
        @keyup.enter.native="confirm"
      />
    </div>

    <span slot="footer" class="dialog-footer">
      <el-button @click="visibleProxy = false">取消</el-button>
      <el-button type="primary" @click="confirm">确认</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: "HostPasswordDialog",
  props: {
    value: {
      type: Boolean,
      default: false
    },
    expectedPassword: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      password: ""
    };
  },
  computed: {
    visibleProxy: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    }
  },
  watch: {
    value(visible) {
      if (!visible) {
        return;
      }

      this.password = "";
      this.$nextTick(() => {
        if (this.$refs.passwordInput) {
          this.$refs.passwordInput.focus();
        }
      });
    }
  },
  methods: {
    confirm() {
      const password = this.password.trim();
      if (!password) {
        this.$message.error("请输入主机密码");
        return;
      }

      if (!this.expectedPassword || password !== this.expectedPassword) {
        this.$message.error("主机密码错误");
        return;
      }

      this.$emit("confirm", password);
    },
    handleClosed() {
      this.password = "";
      this.$emit("closed");
    }
  }
};
</script>

<style lang="scss" scoped>
.host-password-dialog /deep/ .el-dialog {
  position: relative;
  top: 50%;
  max-width: calc(100vw - 32px);
  margin: 0 auto !important;
  transform: translateY(-50%);
  border: 1px solid #2b88f5;
  background: #0e2035;
}

.host-password-dialog /deep/ .el-dialog__header {
  padding: 18px 20px;
  background: linear-gradient(90deg, #3091ff 0%, #023ba3 100%);
}

.host-password-dialog /deep/ .el-dialog__title,
.host-password-dialog /deep/ .el-dialog__headerbtn .el-dialog__close {
  color: #fff;
}

.host-password-dialog /deep/ .el-dialog__body {
  padding: 24px 28px;
  background: #0e2035;
}

.host-password-dialog /deep/ .el-dialog__footer {
  padding: 12px 28px 24px;
  background: #0e2035;
}

.host-password-dialog__content p {
  margin: 0 0 16px;
  color: rgba(255, 255, 255, 0.82);
  font-size: 14px;
  line-height: 22px;
}

.host-password-dialog /deep/ .el-input__inner {
  height: 38px;
  border: 1px solid rgba(63, 175, 255, 0.58);
  background: rgba(48, 145, 255, 0.12);
  color: #fff;
}

.host-password-dialog /deep/ .el-input__inner:focus {
  border-color: #3fafff;
}

.host-password-dialog /deep/ .el-button {
  min-width: 92px;
}
</style>
